<script>
  import { emitter } from '@/main.js';
  export default {
    name: 'PDPSetReminderDisplayLogic',
    data() {
      return {
        pid: '',
        setReminderTag: '',
        embedId: 'pdp-set-reminder-embed',
        atcSelector: '.PDPaddToCart'
      };
    },
    methods: {
      setFavoritesVisible(visible) {
        if (this.embedId !== 'pdp-set-reminder-embed') return;

        const page = document.getElementById('product-page');
        if (page) page.classList.toggle('pdp-set-reminder-active', !visible);

        document.querySelectorAll('[data-pdp-favorite]').forEach(el => {
          el.style.display = visible ? '' : 'none';
        });

        document.querySelectorAll('.pdp-cta-row').forEach(row => {
          if (!visible) {
            row.classList.add('pdp-cta-row--no-favorite');
            return;
          }
          if (row.querySelector('[data-pdp-favorite]')) {
            row.classList.remove('pdp-cta-row--no-favorite');
          }
        });
      },
      handleSetReminderTagFound() {
        const embed = document.getElementById(this.embedId);
        const atc = this.$el.closest(this.atcSelector) || document.querySelector(this.atcSelector);
        if (embed) embed.style.display = 'block';
        if (atc) atc.style.display = 'none';
        this.setFavoritesVisible(false);
      },
      resetDisplay() {
        const embed = document.getElementById(this.embedId);
        const atc = this.$el.closest(this.atcSelector) || document.querySelector(this.atcSelector);
        if (embed) embed.style.display = 'none';
        if (atc) atc.style.display = 'block';
        this.setFavoritesVisible(true);
      },
      handlePdpTagsUpdated(e) {
        this.resetDisplay();
        e.tags.forEach(tag => {
          if (tag === this.setReminderTag) {
            this.handleSetReminderTagFound();
          }
        });
      }
    },
    mounted() {
      const wrapper = this.$el.parentElement;
      this.setReminderTag = wrapper.getAttribute('data-set-reminder-tag');
      this.embedId = wrapper.getAttribute('data-embed-id') || 'pdp-set-reminder-embed';
      this.atcSelector = wrapper.getAttribute('data-atc-selector') || '.PDPaddToCart';
      emitter.on('pdp-tags-updated', this.handlePdpTagsUpdated);

      const rawTags = wrapper.getAttribute('data-product-tags');
      if (rawTags) {
        try {
          const tags = JSON.parse(rawTags);
          this.handlePdpTagsUpdated({ tags });
        } catch (_) {
          // Ignore malformed embedded product tag JSON.
        }
      }
    },
    unmounted() {
      emitter.off('pdp-tags-updated', this.handlePdpTagsUpdated);
    }
  };
</script>

<template>
  <div style="display: none"></div>
</template>
